<template>
  <floor
    class="shop-floor"
    :showEmpty="isEmpty"
    :emptyImage="require('@/assets/images/puhui/sy-w3.png')"
    :emptyText="emptyText"
    showMoreText="寻找更多商家   >>"
    @show-more="$router.push('/store-list?NearestToMe=1')"
  >
    <span class="shop-floor-title" slot="title">
      <van-icon :name="require('@/assets/svg/location.svg')" /> 附近特惠商家
    </span>
    <div class="shop-list">
      <div class="shop-item" v-for="(item, i) in shops" :key="i" @click="$router.push(`/mall/shop?id=${item.id}`)">
        <div class="shop-logo">
          <van-image lazy-load fit="cover" width="100%" height="100%" :src="item.logoPictureUrl" />
        </div>
        <div class="shop-info">
          <div class="shop-title van-ellipsis">{{ item.name }}</div>
          <div class="shop-address van-multi-ellipsis--l2">
            <van-icon :name="require('@/assets/images/dinwei.png')" />
            {{ item.address }}
          </div>
        </div>
        <div class="shop-distance">
          <div>
            <van-icon :name="require('@/assets/images/fly.png')" />
            {{ item.distance | formatDistance }}
          </div>
          <img v-lazy="require('@/assets/images/arrow.png')" />
        </div>
      </div>
    </div>
  </floor>
</template>

<script>
import Floor from './components/Floor'
import { searchNearbyStores } from '@/api/search'
import getCurrentPosition from '@/mixins/getCurrentPosition'

export default {
  name: 'ShopFloor',
  mixins: [getCurrentPosition],
  components: {
    Floor
  },
  data() {
    return {
      shops: [],
      isEmpty: false,
      emptyText: ''
    }
  },
  filters: {
    formatDistance: distance => {
      if (distance > 20000) {
        return '>20km'
      }

      if (distance > 1000) {
        return (distance / 1000).toFixed(2) + 'km'
      }

      return distance + 'm'
    }
  },
  methods: {
    /**
     * 定位成功
     */
    onLocateSuccess(position) {
      this.loadShops({
        lon: position.longitude,
        lat: position.latitude,
        limit: 3
      })
    },

    /**
     * 定位失败
     */
    onLocateFailed(error) {
      this.isEmpty = true
      this.emptyText = error.message
    },

    /**
     * 加载店铺
     */
    loadShops(params) {
      searchNearbyStores(params).then(res => {
        const result = (this.shops = res.data.data)
        if (result.length === 0) {
          this.isEmpty = true
          this.emptyText = '附近还没有商家哦 ~'
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.shop {
  &-floor::after {
    display: none;

    &-title {
      font-size: 18px;
    }
  }

  &-list {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &-item {
    height: 85px;
    position: relative;
    display: flex;
    border: 1px solid #e4e5e5;
    border-radius: 2px;
    overflow: hidden;

    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }

  &-logo {
    height: 75px;
    width: 75px;
    padding: 5px;
  }

  &-info {
    max-width: 180px;
    padding: 12px 0 0 15px;
  }

  &-title {
    font-size: 15px;
    font-weight: 400;
  }

  &-address {
    max-width: 180px;
    position: absolute;
    bottom: 8px;
    color: #595757;
    font-size: 12px;
  }

  &-distance {
    position: absolute;
    right: 15px;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 10px;
    color: #898989;

    & > img {
      width: 32px;
      margin-top: 5px;
    }
  }
}
</style>
